import { PageHero } from "../components/common/PageHero";
import { WhyFrontxGrid } from "../components/sections/WhyFrontxGrid";
import { ProcessTimeline } from "../components/sections/ProcessTimeline";
import { Marquee } from "../components/common/Marquee";
import { FinalCTA } from "../components/sections/FinalCTA";
import { images } from "../data/content";

export default function WhyFrontx() {
    return (
        <>
            <PageHero
                overline="Why FRONTX"
                breadcrumb="Why FRONTX"
                title="Why Businesses Choose FRONTX"
                subtitle="A single integrated partner combining scalable manpower with construction and project execution capabilities across India."
                image={images.officeTeam}
            />
            <WhyFrontxGrid />
            <Marquee items={["Reliable", "Professional", "Scalable", "PAN India", "Enterprise Ready"]} />
            <ProcessTimeline />
            <FinalCTA />
        </>
    );
}
